import React, { createRef, useRef, useEffect } from 'react';

// Styles
import { ContentWrapperStyled, NoEntriesWrapperStyled } from './List.styled';
import { TitleStyled } from '../../library/Text.styled';
import { NoResultsIconStyled } from '../../library/Icons.styled';

// Components
import ListEntry from '../ListEntry/ListEntry';

const List = (props) => {
	const { entries, currentSelected, setHighlight } = props;

	// Create reference to the list items
	const refs = useRef({});
	const listRef = createRef();

	useEffect(() => {
		// Only allow scroll to when is a single course
		if (currentSelected.type === 'single') {
			listRef.current.scrollTop =
				refs.current[currentSelected.entry.id].current.offsetTop;
		}
	}, [currentSelected, entries, listRef]);

	return (
		<ContentWrapperStyled ref={listRef}>
			{entries.map((entry, index) => (
				<ListEntry
					key={index}
					ref={(refs.current[entry.id] = createRef())}
					entry={entry}
					currentSelected={currentSelected}
					setHighlight={setHighlight}
				/>
			))}
			{entries.length <= 0 && (
				<NoEntriesWrapperStyled>
					<NoResultsIconStyled></NoResultsIconStyled>
					<TitleStyled className={'color-dark'}>
						Sorry, we could not find any courses.
					</TitleStyled>
				</NoEntriesWrapperStyled>
			)}
		</ContentWrapperStyled>
	);
};

export default List;
